import InputField from '@components/common/InputField'
import React, { useState } from 'react'

const InputPasswordWithStrength = ({password, setPassword, ...props}) => {
	const [score, setScore] = useState(0)

	const strengthLabels = ['Weak', 'Fair', 'Good', 'Strong']
  	const colors = ['bg-red-500', 'bg-[#EAB308]', 'bg-green-500', 'bg-blue-500']

	const calculateStrength = (password) => {
		let newScore = 0

		// Rules for scoring
		if (password.length >= 8) newScore += 1 // Minimum length
		if (/[A-Z]/.test(password)) newScore += 1 // Contains uppercase
		if (/[a-z]/.test(password)) newScore += 1 // Contains lowercase
		if (/[^A-Za-z0-9]/.test(password)) newScore += 1 // Contains special characters

		setScore(newScore)
	}

	const handleChange = (e) => {
		const newPassword = e.target.value
		setPassword(newPassword)
		calculateStrength(newPassword)
	}

	return (
		<div className="password-strength w-full">
			<InputField
				onChange={(e) => handleChange(e)}
				{...props}
			/>
			<div className="mt-2">
				<div className="flex space-x-1">
					{Array(4)
						.fill(0)
						.map((_, index) => (
						<div
							key={index}
							className={`h-2 flex-1 rounded ${
							index < score ? colors[score - 1] : 'bg-gray-300'
							}`}
						></div>
					))}
				</div>
				<p className={`mt-2 text-sm text-right ${password.trim() === '' && 'hidden'}`}>
					{strengthLabels[score - 1] || 'Very Weak'}
				</p>
			</div>
		</div>
	);
}


export default InputPasswordWithStrength